/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Email_TitleInputs */

const en_form_email_title = /** @type {(inputs: Form_Email_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter your email`)
};

const ar_form_email_title = /** @type {(inputs: Form_Email_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يرجى إدخال بريدك الإلكتروني`)
};

const bn_form_email_title = /** @type {(inputs: Form_Email_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার ইমেইল লিখুন`)
};

const de_form_email_title = /** @type {(inputs: Form_Email_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte geben Sie Ihre E-Mail-Adresse ein`)
};

const es_form_email_title = /** @type {(inputs: Form_Email_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor ingresa tu correo electrónico`)
};

const fr_form_email_title = /** @type {(inputs: Form_Email_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez saisir votre email`)
};

const pt_form_email_title = /** @type {(inputs: Form_Email_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor insira seu e-mail`)
};

const zh_form_email_title = /** @type {(inputs: Form_Email_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入您的电子邮件`)
};

const tr_form_email_title = /** @type {(inputs: Form_Email_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lütfen e-posta adresinizi girin`)
};

const ru_form_email_title = /** @type {(inputs: Form_Email_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, введите свой адрес электронной почты`)
};

const pl_form_email_title = /** @type {(inputs: Form_Email_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proszę podać swój adres e-mail`)
};

/**
* | output |
* | --- |
* | "Please enter your email" |
*
* @param {Form_Email_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const form_email_title = /** @type {((inputs?: Form_Email_TitleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Email_TitleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_form_email_title(inputs)
	if (locale === "bn") return bn_form_email_title(inputs)
	if (locale === "de") return de_form_email_title(inputs)
	if (locale === "es") return es_form_email_title(inputs)
	if (locale === "fr") return fr_form_email_title(inputs)
	if (locale === "pt") return pt_form_email_title(inputs)
	if (locale === "zh") return zh_form_email_title(inputs)
	if (locale === "tr") return tr_form_email_title(inputs)
	if (locale === "ru") return ru_form_email_title(inputs)
	if (locale === "pl") return pl_form_email_title(inputs)
	return en_form_email_title(inputs)
});